export const getStoredItem = (key) => {
  console.log('key', key, localStorage.getItem(key));
  const getStorage = localStorage.getItem(key);
  if (getStorage === null) {
    return null;
  }

  return JSON.parse(getStorage);
};

export const storeItem = (key, value) => {
  if (typeof window != undefined) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};

export const clearItems = (items) => {
  if (Array.isArray(items)) {
    items.forEach((item) => localStorage.removeItem(item));
  }
};
